import { CommanderThunkAction } from '@mews-commander/types';
import { DurationService, lt, showSuccessAlert } from '@mews/framework';
import { refreshPage } from '../../app/actions/common';
import { ExtendEHWFormValues } from './types';

export const extendEHW =
    ({ enterpriseId, aehwDays, aehwHours, oehwDays, oehwHours }: ExtendEHWFormValues): CommanderThunkAction =>
    async (dispatch, getState, { repositories }) => {
        const aehwDuration = DurationService.fromObject({
            day: aehwDays,
            hour: aehwHours,
        });

        const oehwDuration = DurationService.fromObject({
            day: oehwDays,
            hour: oehwHours,
        });

        const accountingEditableHistoryWindow = DurationService.toString(aehwDuration);
        const operationalEditableHistoryWindow = DurationService.toString(oehwDuration);

        return repositories.enterprises
            .extendEHW({
                enterpriseId,
                accountingEditableHistoryWindow,
                operationalEditableHistoryWindow,
            })
            .then(() => {
                showSuccessAlert({ title: lt('Success'), description: lt('EditableHistoryWindowUpdatedMessage') });
                dispatch(refreshPage());
            });
    };
